// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"d24c0c78","210":"370fe705","384":"e0c5e55d","614":"4c47426d","701":"b82ec38f"}[chunkId] + ".chunk.css";
};